const riot = require('riot');

riot.tag2('modal-referred-note', '<div class="relative f fclm w70per h90per max-height-800 py24 overflow-hidden rounded-12 bg-white mx16 s-w-full s-px8 m-w-full" ref="modal"><i class="icon-close absolute t16 r16 fs24 text-label_dark_medium cursor-pointer" onclick="{close}"></i> <div class="text-center lh15 fs16 bold mb32">関連ノートの作成</div> <div class="px48 overflow-y-scroll mb24 s-px16"> <div class="f mb24 s-flex-column"> <div class="s-mb16 mr24 s-mr0"> <div class="lh13 bold mb8">作成先プロジェクト</div> <div class="f fm py6 lh13 word-break-all line-clamp-1 bold">{project.data.name}</div> </div> <div> <div class="lh13 bold mb8">テンプレート選択</div> <button class="f fm w200 px8 py6 rounded-8 bg-background_light_secondary border border-separator_opacity text-left hover-trigger hover-border-primary focus-outline-pale" type="button" onclick="{onOpenPopupTemplates}"> <div class="w-full lh13 word-break-all line-clamp-1 bold">{selectedTemplateTitle}</div> </button> </div> </div> <div class="mb24"> <div class="lh13 bold mb8">ノート内容</div> <div class="w-full h400 rounded-8 overflow-hidden bg-background_light_secondary border border-separator_opacity focus-outline-pale"> <div class="s-full" ref="editor" data-is="atom-editor" project="{opts.project}"></div> </div> </div> <div class="mb24"> <div class="lh13 bold mb8">参照ノートリンク</div> <input class="input focus-pale light_secondary w-full px30" ref="referrer" type="text" riot-value="{referrer}"> </div> <div class="f fb mb8"> <label class="flex-fixed f fm cursor-pointer mr16"> <input class="checkbox mr4" ref="relationCheck" type="checkbox" checked="{true}"> <div class="lh15 fs12 hover-trigger hover-text-primary mr4">参照を残す</div><i class="icon-help cursor-pointer fs16 text-label_dark_primary tooltip" aria-label="参照元に作成ノートの参照を残すことができます。" data-tooltip-position="top"></i> </label> </div> </div> <div class="f fc"> <button class="relative button primary f fh w200 h44" type="button" onclick="{createNote}" disabled="{refs.editor.isUploading || isCreating}"> <div class="w50" if="{!(refs.editor.isUploading || isCreating)}">作成</div> <div class="absolute t0 l0 r0 f fh" if="{refs.editor.isUploading || isCreating}"> <div class="s20" data-is="atom-loading"></div> </div> </button> </div> </div>', 'modal-referred-note,[data-is="modal-referred-note"]{background-color:rgba(0,0,0,0.5)}', 'class="f fh" spat-animation="push"', function(opts) {

    const DISTANCE_TO_POPUP = 8;

    const INIT_TITLE_START_INDEX = 0;
    const INIT_TITLE_END_INDEX = 20;
    const trimMentionMessage = this.opts.item?.replace(/(^|\s)@([\S]+)/g, '').trim();
    const insertMessage = trimMentionMessage ? '\n\n\n## 参照メッセージ\n' + trimMentionMessage : '';
    this.project = this.opts.project;
    this.selectedTemplateTitle = '未選択';
    this.referrer = `[**${this.opts.note.data.title || 'タイトルなし'}**](/${this.opts.note.path}?view=list)`;
    this.isCreating = false;

    this.on('mount', () => {
      let editorTag = this.refs.editor;

      let trimMarkMessage = app.utils.removeMd(trimMentionMessage);
      let init_title = trimMarkMessage.replace(/\n|\r/g, '').trim().substring(INIT_TITLE_START_INDEX, INIT_TITLE_END_INDEX);
      editorTag.on('submit', () => {

        if (this.refs.editor.isUploading || this.isCreating) return ;
        this.createNote();
        this.update();
      });

      requestAnimationFrame(() => {
        editorTag.setValue(`# ${trimMentionMessage ? init_title + insertMessage : this.opts.note.data.title}`);
        editorTag.focus();
        editorTag.editor.setCursor({ line:0, ch: Infinity });
      });
      this.update();
    });

    this.createNote = async () => {
      this.isCreating = true;
      let content = '';
      let editorValue = this.refs.editor.getValue();
      let referrer = '\n\n## 参照ノート\n' + this.refs.referrer.value + '\n';
      content = editorValue + referrer;
      let title = app.utils.getTitle(content);
      try {
        let note = await this.project.createNote({title, content});
        let note_path = `/${this.project.path}/notes/${note.id}?view=list`;

        await app.api.child(`/${this.project.path}/notes/${this.opts.note.id}`).put({
          child_note_ids: [
            ...this.opts.note.data.child_note_refs.map(ref => ref.id),
            note.id,
          ],
        });

        if (this.refs.relationCheck.checked) {

          this.postReferredLog(note.title, note_path);
        }
        this.close();

        spat.router.push(note_path);
      }
      catch(e) {
        console.log(e.message);
      }
      finally {
        this.isCreating = false;
      }
    };

    this.postReferredLog = async (title, path) => {
      try {
        await app.api.child(`/${this.opts.project.path}/notes/${this.opts.note.id}/messages`).post({
          content: `関連ノートが作成されました\n\n[**${title}**](${path})`,
        });
      }
      catch (e) {
        console.log(e.message);
      }
    };

    this.onOpenPopupTemplates = (e) => {
      const popup = spat.popup.open('popup-note-templates', {
        element: e.currentTarget,

        closeTarget: e.currentTarget,
        offsetTop: DISTANCE_TO_POPUP,
        position: 'bottom',
        opts: {
          project: this.project,
          omitCreate: true,
          disableMultiNoteCreate: true,
        },
      }).on('select', (e) => {
        this.setTemplateElement(e.item);
        this.selectedTemplateTitle = e.item.data.title;
        this.update();
        popup.close();
      });
    };

    this.setTemplateElement = async (item) => {

      let content = await app.utils.getTemplateContent(item);
      this.refs.editor.setValue(content + insertMessage);
    };
});